<template>
  <div class="team-member">
    <div class="team-member__image">
      <span
        data-testid="team-member-solved-rev-icon"
        v-if="solvedRev"
        class="material-icons"
      >
        star
      </span>
      <ImageMedia
        class="team-member__avatar"
        :size="IMAGE_SIZES.SQUARE"
        :src="avatarMediaObject"
        :defaultImage="defaultImage"
      />
    </div>
    <div class="team-member__text">
      <p
        data-testid="team-member-name"
        v-if="name || lastName"
        class="team-member__name"
      >
        {{ name }} {{ lastName }}
      </p>
      <p v-else data-testid="team-member-mail" class="team-member__name">
        {{ email }}
      </p>
      <span
        data-testid="team-member-solved-rev"
        v-if="solvedRev"
        class="team-member__subtitle"
        >{{ $t('quick_action.solved_the_issue') }}</span
      >
    </div>
  </div>
</template>

<script>
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import defaultImage from '@/assets/images/user.svg'
import { IMAGE_SIZES } from 'rever-media-sdk'

export default {
  name: 'TeamMember',

  data() {
    return {
      defaultImage,
      IMAGE_SIZES,
    }
  },

  components: {
    ImageMedia,
  },

  props: {
    avatarMediaObject: {
      type: Object,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: false,
    },
    email: {
      type: String,
      required: false,
    },
    solvedRev: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen, print {
  .team-member__text {
    position: relative;
  }
  .team-member__image {
    position: relative;
  }
  .material-icons {
    font-size: 14px;
    position: absolute;
    top: 0;
    right: 15%;
    color: $color-blue-grey-darken2;
  }
  .team-member {
    display: flex;
    width: 100%;
  }
  .team-member__subtitle {
    position: absolute;
    top: 44%;
    font-size: 7px;
    margin: 0;
    color: $color-blue-grey-darken3;
  }

  .team-member__avatar {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    margin-right: 8px;
    object-fit: cover;
  }

  .team-member__name {
    margin: 0px;
    padding: 0px;
    color: $color-blue-grey-darken3;
    font-size: 12px;
    width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
